import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M4 9h16v2H4zm0 4h16v2H4z"
}), 'DragHandleTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/DragHandleTwoTone.js
// module id = 3272
// module chunks = 2